import { render, staticRenderFns } from "./demographic-icons.vue?vue&type=template&id=162d3620&"
import script from "./demographic-icons.vue?vue&type=script&lang=js&"
export * from "./demographic-icons.vue?vue&type=script&lang=js&"
import style0 from "./demographic-icons.vue?vue&type=style&index=0&id=162d3620&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports